export default [
  {
    path: '/:pathMatch(.*)',
    meta: {
      title: "Application L'Outil",
      public: true,
    },
    redirect: {
      path: '/',
    },
  },
  {
    path: '/login',
    meta: {
      title: "Login - Application L'Outil",
      public: true,
    },
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/users/changePassword',
    meta: {
      public: true,
    },
    name: 'ChangePassword',
    component: () => import('@/views/ChangePassword.vue'),
  },
  {
    path: '/',
    name: 'Home',
    meta: {
      title: "Accueil - Application L'Outil",
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      title: "Tableau de bord - Application L'Outil",
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: '/users',
    name: 'Users',
    meta: {
      title: "Utilisateurs - Application L'Outil",
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Users/list.vue'),
  },
  {
    path: '/users/add',
    name: 'UsersAdd',
    meta: {
      title: "Nouvel Utilisateur - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Users/crud.vue'),
  },
  {
    path: '/users/:id',
    name: 'UsersEdit',
    meta: {
      title: "Utilisateur - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Users/crud.vue'),
  },
  {
    path: '/profile',
    name: 'ProfileInfoEdit',
    meta: {
      title: "Profile - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Profile/crud.vue'),
  },
  {
    path: '/materials',
    name: 'Materials',
    meta: {
      title: "Matériaux - Application L'Outil",
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Materials/list.vue'),
  },
  {
    path: '/labors',
    name: 'Labors',
    meta: {
      title: "Métiers - Application L'Outil",
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Labors/list.vue'),
  },
  {
    path: '/labors/:id',
    name: 'LaborsEdit',
    meta: {
      title: "Métier - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Labors/crud.vue'),
  },
  {
    path: '/jobs',
    name: 'Jobs',
    meta: {
      title: "Soumissions - Application L'Outil",
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Jobs/list.vue'),
  },
  {
    path: '/jobs/add',
    name: 'JobsAdd',
    meta: {
      title: "Nouvelle Soumission - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Jobs/add.vue'),
  },
  {
    path: '/jobs/:id',
    name: 'JobsEdit',
    meta: {
      title: "Soumission - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Jobs/edit.vue'),
  },
  {
    path: '/composites',
    name: 'Composites',
    meta: {
      title: "Assemblages - Application L'Outil",
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Composites/list.vue'),
  },
  {
    path: '/composites/add',
    name: 'CompositesAdd',
    meta: {
      title: "Nouvel Assemblage - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Composites/crud.vue'),
  },
  {
    path: '/composites/:id',
    name: 'CompositesEdit',
    meta: {
      title: "Assemblage - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Composites/crud.vue'),
  },
  {
    path: '/importation/materials',
    name: 'Importation_Materials',
    meta: {
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Importation/materials.vue'),
  },
  {
    path: '/reports/:id',
    name: 'Reports',
    meta: {
      title: "Rapport - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Reports/report.vue'),
  },
  {
    path: '/companies',
    name: 'Companies',
    meta: {
      title: "Compagnies - Application L'Outil",
      requiresAuth: true,
      breadcrumb: true,
    },
    component: () => import('@/views/Companies/list.vue'),
  },
  {
    path: '/companies/add',
    name: 'CompaniesAdd',
    meta: {
      title: "Nouvelle Compagnie - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Companies/crud.vue'),
  },
  {
    path: '/companies/:id',
    name: 'CompaniesEdit',
    meta: {
      title: "Compagnie - Application L'Outil",
      requiresAuth: true,
      breadcrumb: false,
    },
    component: () => import('@/views/Companies/crud.vue'),
  },
];
